import { stringToSelectItem } from 'bones/utils/select/stringToSelectItem';
import { SelectItem } from 'bones/utils/select/types';

export const createNewSelectItemFromQuery = (item: string): SelectItem => ({
  ...stringToSelectItem(item),
  isNewlyCreated: true,
});
